import { render, staticRenderFns } from "./BridgeStatsSection.vue?vue&type=template&id=612f2288&scoped=true"
import script from "./BridgeStatsSection.vue?vue&type=script&lang=ts"
export * from "./BridgeStatsSection.vue?vue&type=script&lang=ts"
import style0 from "./BridgeStatsSection.vue?vue&type=style&index=0&id=612f2288&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612f2288",
  null
  
)

export default component.exports